import React, { useContext, useState, useEffect } from "react";
import { StateContext } from "../../context/Context";
import { format, addBusinessDays } from "date-fns";
import api from "../../services/api";

import { Container } from "./styles";
import { notificar } from "../Notificador";
import { refreshFrete, clearCart, criaPix } from "../../services/utils";
import { useHistory } from "react-router-dom";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GeraPix from "../GeraPix";

/**
 * Pagamento de PEDIDO da loja (cartão e pix).
 *
 * BOLETO: removido em 2026-08-16, junto com o formulário do boleto sem registro
 * (`components/FormBoleto`), por decisão do dono do produto. A loja já não
 * oferecia boleto — `pages/Cart/Pay` filtra a forma 5 da lista há tempos, e a
 * última parcela de boleto de E-commerce é de maio/2025. As antigas em aberto
 * estão todas vencidas há mais de um ano; para essas, o caminho é falar com a
 * produtora, não emitir um registro novo no banco.
 */
export default function GeraPagamento(props) {
  const history = useHistory();
  const context = useContext(StateContext);
  const {
    //`montar`/`icone`/`texto`/`className` só serviam à 2ª via do boleto antigo;
    //ficam aceitos para não quebrar quem ainda passa, mas não são usados.
    via = 1,
    forma,
    //estes são para criar uma parcela nova
    contrato,
    valor,
    tipo,
    prazo = 5,
    venda = null,
    desconto = 0,
    comPedido = false, //se true, indica um pedido associado. Preencher venda com o id do pedido
  } = props;
  const [showPix, setShowPix] = useState(false);
  const [showCartao, setShowCartao] = useState(false);
  const [lnkCartao, setLnkCartao] = useState("");
  const [dadosPix, setDadosPix] = useState([]);
  const vencimento = addBusinessDays(new Date(), prazo);

  const createParcela = () => {
    if (via === 1) {
      //cria requisição de pagamento
      let dataParcela = {
        parcconta: contrato,
        parcvalor: valor,
        parcdesconto: desconto,
        parctipo: tipo,
        parcforma: forma,
        parcvencimento: format(vencimento, "yyyy-MM-dd"),
        parctransacao: null,
        parcadmin: "Portal",
        parcorigem: "Portal",
      };
      //verifica se vem de um outro tipo de venda
      if (venda !== null) {
        dataParcela.parcvenda = venda;
      }

      //verifica se é pedido e cria um id
      if (comPedido) {
        const current_timestamp = format(new Date(), "yyyy-MM-dd HH:mm:ss");
        api.get(`pedidos/novo`).then((dados) => {
          dataParcela.parcvenda = dados.data.pedId;

          if (dataParcela.parcvalor - dataParcela.parcdesconto === 0) {
            dataParcela.parcpagoem = current_timestamp;
            dataParcela.parcdoc = "Pacote contratado";
          }
          //cria parcela
          api.post(`pagamentos/novaparcela`, dataParcela).then((dados) => {
            if (!dados.data.error) {
              // cria requisição
              const { cart, checkout } = context.state;
              //dados para envio
              let dataPedido = {
                order: { cart, checkout, financeiro: dados.data },
                pedido: {
                  pedFrete:
                    checkout.frete.length > 0 &&
                    checkout.frete[0].hasOwnProperty("valor")
                      ? checkout.frete[0].valor
                      : 0,
                  pedModalidadeFrete:
                    checkout.frete.length > 0 ? checkout.frete[0].nome : null,
                  pedQuantidade: cart.reduce((a, b) => a + b.qt, 0),
                  pedImpressa: refreshFrete(cart),
                  pedSoDigital: !refreshFrete(cart),
                  /* pedObs: checkout.obs, TODO */
                  pedDesconto: checkout.descontos.total,
                  pedTotal: checkout.bruto,
                },
              };
              //consulta descontos e isenções
              if (
                dataPedido.pedido.pedTotal - dataPedido.pedido.pedDesconto ===
                0
              ) {
                dataPedido.pedido.pedFinanceiro = current_timestamp;
                dataPedido.pedido.pedDoc = "Pacote contratado";
                dataPedido.pedido.pedAdmFinanceiro = "Portal";
                dataPedido.pedido.pedAdmin = "Portal";

                //pula a linha de produção caso desnecessária
                if (!refreshFrete(cart)) {
                  dataPedido.pedido.pedProcessamento = current_timestamp;
                  dataPedido.pedido.pedOk = current_timestamp;
                  dataPedido.pedido.pedEntregue = current_timestamp;
                  dataPedido.pedido.pedAdmEntrega = "Portal";
                }
              }

              api.post(`pedidos/preencher`, dataPedido).then((dados) => {
                dataPedido.parcvenda = dados.pedId;
                //notificar por email aqui
                if (
                  dataPedido.pedido.pedOk &&
                  dataPedido.pedido.pedOk !== null
                ) {
                  api.post(`notificar/pedido/${dataParcela.parcvenda}`);
                }
                notificar(`Pedido efetuado com sucesso.`, "verde");
                context.actions.setCheckout({
                  frete: {},
                  descontos: [],
                  bruto: 0,
                  liquido: 0,
                });
                /* history.push(
                  `/resumo/E-commerce/${dataPedido.order.financeiro.parcid}-${dataPedido.order.financeiro.parcvenda}-${dataPedido.order.financeiro.parcconta}`
                ); */ //terceiro dado é conta e não usuário
              });

              if (forma === 2) {
                api
                  .post(`pagamentos/linkCheckout`, dataPedido)
                  .then((dados) => {
                    setLnkCartao(dados.data.checkoutUrl);
                    setShowCartao(true);
                    notificar(
                      `Clique em 'PAGAR AGORA' para ser redirecionado para a Cielo.`
                    );
                  });
              } else if (forma === 6) {
                const pix =
                  (context.state.cadastro && context.state.cadastro.pix) || {};
                const code = criaPix({
                  chave: pix.chave,
                  mensagem: `${tipo} ${
                    tipo === "E-commerce"
                      ? dataPedido.order.financeiro.parcvenda
                      : dataPedido.order.financeiro.parcconta
                  }`,
                  titular: pix.titular,
                  cidade: pix.cidade,
                  transacao: `${dataPedido.order.financeiro.parcid}`,
                  valor: dataPedido.order.financeiro.parcvalor,
                });

                api
                  .post(
                    `pagamentos/pix/${dataPedido.order.financeiro.parcid}`,
                    { code: code }
                  )
                  .then((dados) => {
                    setDadosPix(dataPedido.order.financeiro);
                    setShowPix(true);
                  });
                //notificar(`Clique em 'EXIBIR BOLETO' para emitir agora.`);
              } else {
                history.push("/");
              }
            }
          });
        });
      } else {
        api.post(`pagamentos/novaparcela`, { dataParcela }).then((dados) => {
          if (!dados.data.error) {
            notificar(`Pedido efetuado com sucesso.`, "verde");
            history.push("/");
            return dados.data;
          }
        });
      }
    }
    // `via === 2` (montar) era a 2ª via do boleto sem registro. Sem esse
    // caminho, não há o que fazer aqui — ver o comentário no topo do arquivo.
  };

  useEffect(() => {
    createParcela();
    /* return function cleanup() {
      clearCart("gera");
    }; */
  }, []);

  return (
    <Container>
      {forma === 6 && showPix && (
        <GeraPix dados={dadosPix} onClick={(e) => e.stopPropagation()} />
      )}
      {forma === 2 && showCartao && (
        <a
          href={lnkCartao}
          style={{
            padding: "5px",
            margin: "5px",
            backgroundColor: "#ccc",
            textDecoration: "none",
          }}
          rel="noopener noreferrer"
          className="icone-e-texto"
          onClick={(e) => e.stopPropagation()}
        >
          <FontAwesomeIcon icon={faCreditCard} />
          PAGAR AGORA
        </a>
      )}
    </Container>
  );
}
